import React, { useState, useRef, useEffect } from "react";
import FaqItem from "./component/index";

import "./style.css";
import "./styles.scss";
import arrowNew from "./img/arrow_new_noback.png";
import { useTranslation } from 'react-i18next';
import { initGA, logPageView } from "../../analytics";
import {getFaqDataList} from './dependencies/action'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

// const faqsData = [
//   {
//     id: 1,
//     title: 1,
//     questionAnswerArray: [
//       {
//         question: "Am I eligible to be a mentee?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat iusto fuga praesentium optio, eaque rerum! Providentsimilique accusantium nemo autem. Veritatis obcaecati tenetur iureeius earum ut molestias architecto voluptate aliquam nihil,eveniet aliquid culpa officia aut! Impedit sit sunt quaerat,odittenetur error, harum nesciunt ipsum debitis quas aliquid.Reprehenderit, quia.",
//       },
//       {
//         question: "How can i get recognized as a startup by DPIIT?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat iusto fuga praesentium optio, eaque rerum! Providentsimilique accusantium nemo autem. Veritatis obcaecati tenetur iureeius earum ut molestias architecto voluptate aliquam nihil,eveniet aliquid culpa officia aut! Impedit sit sunt quaerat,odittenetur error, harum nesciunt ipsum debitis quas aliquid.Reprehenderit, quia.",
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: 2,
//     questionAnswerArray: [
//       {
//         question: "Am I eligible to be a mentee?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat iusto fuga praesentium optio, eaque rerum! Providentsimilique accusantium nemo autem. Veritatis obcaecati tenetur iureeius earum ut molestias architecto voluptate aliquam nihil,eveniet aliquid culpa officia aut! Impedit sit sunt quaerat,odittenetur error, harum nesciunt ipsum debitis quas aliquid.Reprehenderit, quia.",
//       },
//       {
//         question: "How can i get recognized as a startup by DPIIT?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat iusto fuga praesentium optio, eaque rerum! Providentsimilique accusantium nemo autem. Veritatis obcaecati tenetur iureeius earum ut molestias architecto voluptate aliquam nihil,eveniet aliquid culpa officia aut! Impedit sit sunt quaerat,odittenetur error, harum nesciunt ipsum debitis quas aliquid.Reprehenderit, quia.",
//       },
//       {
//         question: "How can i find a mentor?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat",
//       },
//       {
//         question: "What happens if the mentor I reach out to is unresponsive?",
//         answer:
//           "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maximemollitia, molestiae quas vel sint commodi repudiandae consequunturvoluptatum laborum numquam blanditiis harum quisquam eius sed oditfugiat",
//       },
//     ],
//   },
// ];

const Faq = (props) => {
  const { t } = useTranslation();
  const {
    getFaqDataList, faqData } = props;
    
    useEffect(() => {
      getFaqDataList();
    //  
    }, []);
  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const [showBox1, setShowBox1] = useState(false);
  const [showBox2, setShowBox2] = useState(false);
  const [showBox3, setShowBox3] = useState(false);
  const [showBox4, setShowBox4] = useState(false);
  const [showBox5, setShowBox5] = useState(false);

  const clickFunc1 = () => {
    setShowBox1(!showBox1);
    setShowBox2(false);
    setShowBox3(false);
    setShowBox4(false);
    setShowBox5(false);
  };

  const clickFunc2 = () => {
    setShowBox2(!showBox2);
    setShowBox1(false);
    setShowBox3(false);
    setShowBox4(false);
    setShowBox5(false);
  };

  const clickFunc3 = () => {
    setShowBox3(!showBox3);
    setShowBox1(false);
    setShowBox2(false);
    setShowBox4(false);
    setShowBox5(false);
  };

  const clickFunc4 = () => {
    setShowBox4(!showBox4);
    setShowBox1(false);
    setShowBox2(false);
    setShowBox3(false);
    setShowBox5(false);
  };

  const clickFunc5 = () => {
    setShowBox5(!showBox5);
    setShowBox1(false);
    setShowBox2(false);
    setShowBox3(false);
    setShowBox4(false);
  };

  return (
    <div style={{ background: "#f7f7f7" }} className="faqpagtooltip">
      <div
        style={{ marginTop: "6%", display: "flex", justifyContent: "flex-end" }}
      >
        <div className="formgraphicdivfaq"></div>
      </div>

      <div
        className="app-container"
        style={{
          width: "50%",
          marginBottom: "5%",
          background: "transparent",
          marginTop: "-10%",
        }}
      >
        <div className="faqs-container" style={{ width: "80%" }}>
          <h1 className="faq-heading w-100 homepageFirstHeader">Frequently Asked Questions</h1>

          <div
            class="col-md-4 col-lg-4 col-sm-4 w-100"
            onClick={clickFunc1}
            style={{ cursor: "pointer" }}
          >
            <div
              class="faq-btn newuserTooltip"
              style={{
                backgroundImage: showBox1
                  ? "linear-gradient(#39bad3, #326aad) "
                  : "linear-gradient(#B499C7, #563A96) ",
              }}
            >
              <p className="row" style={{ paddingLeft: "15px" }}>
                <a className="interested-link homepageFirstDescription" style={{ width: "fit-content" }}>
                {t('GENERAL')}
                  {/* GENERAL{" "} */}
                  {/* {faqData && faqData.FAQ.QuizType} */}
                </a>
                <span style={{ width: "fit-content", display: "flex" }}>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox1 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                    }}
                  />
                </span>
              </p>
              <span className="tooltiptext intrestedbtn2 tooltip-bottom">
                          Click to View General FAQ
                        </span>
            </div>
          </div>
          <ul
            className="faqs-list-container"
            style={{ display: showBox1 ? "block" : "none" }}
          >
            <FaqItem question={1} />
          </ul>
          <div
            class="col-md-4 col-lg-4 col-sm-4 w-100"
            onClick={clickFunc2}
            style={{ cursor: "pointer", marginTop: "3em" }}
          >
            <div
              class="faq-btn newuserTooltip "
              style={{
                backgroundImage: showBox2
                  ? "linear-gradient(#39bad3, #326aad) "
                  : "linear-gradient(#B499C7, #563A96) ",
              }}
            >
              <p className="row" style={{ paddingLeft: "15px" }}>
                <a className="interested-link homepageFirstDescription" style={{ width: "fit-content" }}>
                {t('I_AM_A_STARTUP')}
                  {/* I AM A STARTUP{" "} */}
                </a>
                <span style={{ width: "fit-content", display: "flex" }}>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox2 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                    }}
                  />
                </span>
              </p>
              <span className="tooltiptext intrestedbtn2 tooltip-bottom">
                          Click to View Startup FAQ
                        </span>
            </div>
          </div>
          <ul
            className="faqs-list-container"
            style={{ display: showBox2 ? "block" : "none" }}
          >
            <FaqItem question={2} />
          </ul>
          <div
            class="col-md-4 col-lg-4 col-sm-4 w-100"
            onClick={clickFunc3}
            style={{ cursor: "pointer", marginTop: "3em" }}
          >
            <div
              class="faq-btn newuserTooltip"
              style={{
                backgroundImage: showBox3
                  ? "linear-gradient(#39bad3, #326aad) "
                  : "linear-gradient(#B499C7, #563A96) ",
              }}
            >
              <p className="row" style={{ paddingLeft: "15px" }}>
                <a className="interested-link homepageFirstDescription" style={{ width: "fit-content" }}>
                {t('I_AM_A_MENTOR')}
                  {/* I AM A MENTOR{" "} */}
                </a>
                <span style={{ width: "fit-content", display: "flex" }}>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox3 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                    }}
                  />
                </span>
               
              </p>
              <span className="tooltiptext intrestedbtn2 tooltip-bottom">
                          Click to View Mentor FAQ
                        </span>
            </div>
          </div>
          <ul
            className="faqs-list-container"
            style={{ display: showBox3 ? "block" : "none" }}
          >
            <FaqItem question={3} />
          </ul>
          <div
            class="col-md-4 col-lg-4 col-sm-4 w-100"
            onClick={clickFunc4}
            style={{ cursor: "pointer", marginTop: "3em" }}
          >
            <div
              class="faq-btn newuserTooltip"
              style={{
                backgroundImage: showBox4
                  ? "linear-gradient(#39bad3, #326aad) "
                  : "linear-gradient(#B499C7, #563A96) ",
              }}
            >
              <p className="row" style={{ paddingLeft: "15px" }}>
                <a className="interested-link d-flex align-items-end homepageFirstDescription" style={{ width: "fit-content" }}>
                {t('COHORT_BASED_PROGRAMS')}
                  {/* COHORT-BASED PROGRAMS{" "} */}
                  <div>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox4 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "25px",
                      position:"relative",
                      left:"6px"
                    }}
                  />
                  </div>
                </a>
                {/* <span style={{ width: "fit-content", display: "flex" }}>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox4 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                    }}
                  />
                </span> */}
              </p>
              <span className="tooltiptext intrestedbtn2 tooltip-bottom">
                          Click to View Cohort Program FAQ
                        </span>
            </div>
          </div>
          <ul
            className="faqs-list-container"
            style={{ display: showBox4 ? "block" : "none" }}
          >
            <FaqItem question={4} />
          </ul>
          <div
            class="col-md-4 col-lg-4 col-sm-4 w-100"
            onClick={clickFunc5}
            style={{ cursor: "pointer", marginTop: "3em" }}
          >
            <div
              class="faq-btn newuserTooltip"
              style={{
                backgroundImage: showBox5
                  ? "linear-gradient(#39bad3, #326aad) "
                  : "linear-gradient(#B499C7, #563A96) ",
              }}
            >
              <p className="row" style={{ paddingLeft: "15px" }}>
                <a className="homepageFirstDescription interested-link d-flex align-items-center" style={{ width: "fit-content" }}>
                {t('ABOUT_MAARG_PORTAL_BY_STARTUP_INDIA')}
                  {/* ABOUT MAARG PORTAL BY STARTUP INDIA{" "} */}
                  <div className="d-flex align-items-center">
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox5 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                      position:"relative",
                      left:"6px"
                    }}
                  />
                  </div>
                </a>
                {/* <span style={{ width: "fit-content", display: "flex" }}>
                  <img
                    src={arrowNew}
                    // className="pt-5"
                    style={{
                      transform: showBox5 ? "rotate(450deg)" : "rotate(360deg)",
                      width: "20px",
                    }}
                  />
                </span> */}
              </p>
              <span className="tooltiptext intrestedbtn2 tooltip-bottom">
                          Click to View Marg Portal FAQ
                        </span>
            </div>
          </div>
          <ul
            className="faqs-list-container"
            style={{ display: showBox5 ? "block" : "none" }}
          >
            <FaqItem />
          </ul>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
 
  return {
    // getFaqDataList: state.GetFaqReducer.getFaqDataList.list,
   
  };
};
export default connect(mapStateToProps, { getFaqDataList })(
  withRouter(Faq)
);


